/**
 * サンプルクラス
 * @constructor
 */
class Inview {

  constructor() {

    this._addClassNameval = 'is-inView';

    this.init();
  }


  init() {
    // 汎用系 ※下からフェードインで出現
    if (document.querySelector('.js-inView--aos')) {
      this.makeObserver_aos();
    }
  }


  makeObserver_aos() {
    // .js-inView--aosには_init.scssでopacity:0が定義されている
    const targetItem = document.querySelectorAll('.js-inView--aos');
    const options = {
      root: null,
      rootMargin: '-100px 0px',
      thresholdVal: 0
    };
    const observer_aos = new IntersectionObserver(aos_action, options);
    targetItem.forEach(elem => {
      const timeValue = elem.getAttribute('data-inView_aos-time');
      let aosTime;
      if (timeValue) {
        aosTime = timeValue;
      } else {
        aosTime = 1.5;
      }

      elem.style.position = 'relative'; // 要素のスタイルにposition: relativeを追加
      elem.style.transform = 'translate(0, 50px)'; // transform: translate(10px, 10px)を追加
      elem.style.transition = `all ${aosTime}s cubic-bezier(0.165, 0.84, 0.44, 1)`; // transitionを追加
      // elem.style.transition = 'all 0.5s cubic-bezier(0.165, 0.84, 0.44, 1)'; // transitionを追加

      // スタイル設定が完了してからobserveを呼び出す
      setTimeout(() => {
        observer_aos.observe(elem);
      }, 500);
    });
    function aos_action (entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.transform = 'translate(0, 0)';
          entry.target.style.opacity = '1';
        } else {
          return false;
        }
      });
    }
  }

}

export default Inview;
